import { u as updateContentWithVariant, a as getStockStatus, g as getProductData } from './app-chunk-utils-4zL9DDjt.js';
import { B as formatShopifyPrice, C as getScriptTagJson, D as isAboveLarge } from './app-chunk-common-BPZAsnhF.js';
import { t as topbar } from './app-bundle.vendor.js';
import { s as saveViewedProduct } from './app-chunk-utils-S2wKFyPJ.js';
import { s as showModalTerms, M as ModalAtcDisclaimer } from './app-chunk-modal-atc-disclaimer-Ch-oBYSE.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

class UIDropdown extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement} */
    // @ts-ignore
    this.listbox = this.querySelector("ui-dropdown-options");

    /** @type {NodeListOf<HTMLElement>} */
    this.optionItems = this.querySelectorAll("ui-dropdown-option");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.triggerButton = this.querySelector("ui-dropdown-selected");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.handleKeydownEvent = this.handleKeydownEvent.bind(this);
    this.handleClickOutsideEvent = this.handleClickOutsideEvent.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleOptionKeydown = this.handleOptionKeydown.bind(this);

    this.activeElement = null;

    const controlsId = (this.listbox.id = "--listbox");
    this.triggerButton.setAttribute("tabindex", "0");
    this.triggerButton.setAttribute("role", "combobox");
    this.triggerButton.setAttribute("aria-expanded", "false");
    this.triggerButton.setAttribute("aria-haspopup", "listbox");
    this.triggerButton.setAttribute("aria-controls", controlsId);

    this.listbox.setAttribute("role", "listbox");
    this.listbox.setAttribute("tabindex", "-1");
    this.listbox.inert = true;
    this.listbox.id = controlsId;

    this.optionItems.forEach((el) => {
      el.setAttribute("role", "option");
      el.setAttribute("tabindex", "0");
      el.addEventListener("keydown", this.handleOptionKeydown);
    });
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClickEvent);
    this.addEventListener("keydown", this.handleKeydown);
  }

  showOrHideItems() {
    const value = this.getAttribute("value") || "";
    this.querySelectorAll("ui-dropdown-option").forEach(
      // @ts-ignore
      /** @param {HTMLElement} el */ (el) => {
        if (el.getAttribute("value") === value) {
          el.style.display = "none";
        } else {
          el.style.display = "";
        }
      }
    );
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydown(event) {
    const { key } = event;
    const state = this.getAttribute("data-state") || "";

    if (key === "Tab") {
      return;
    }

    if (state === "opening" || state === "closing") {
      event.preventDefault();
      return;
    }

    if (key === "Enter" || key === " ") {
      event.preventDefault();
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }

    if (key === "Escape") {
      event.preventDefault();
      this.close();
      this.triggerButton.focus();
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleOptionKeydown(event) {
    const { key } = event;
    let handled = false;

    switch (key) {
      case " ":
      case "Enter":
        event.preventDefault();
        // @ts-ignore
        this.selectItem(event.target);
        this.close();
        handled = true;
        break;
      case "Tab":
        this.close();
        break;
      case "ArrowUp":
        this.selectPreviousItem();
        handled = true;
        break;
      case "ArrowDown":
        this.selectNextItem();
        handled = true;
        break;
      case "Tab":
        this.close();
        handled = true;
        break;
    }

    if (handled) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  selectPreviousItem() {
    const items = this.getVisibleItems();
    let prevIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        prevIndex = i - 1;
        break;
      }
    }

    if (items[prevIndex]) {
      this.activeElement = items[prevIndex];
      this.activeElement.focus();
    }
  }

  selectNextItem() {
    const items = this.getVisibleItems();
    let nextIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        nextIndex = i + 1;
        break;
      }
    }

    if (items[nextIndex]) {
      this.activeElement = items[nextIndex];
      this.activeElement.focus();
    }
  }

  open() {
    this.showOrHideItems();
    this.listbox.setAttribute("data-state", "opening");
    this.listbox.inert = false;

    const items = this.getVisibleItems();

    window.setTimeout(() => {
      this.setAttribute("data-state", "open");

      if (items.length > 0) {
        const item = items[0];
        item.focus();
        this.activeElement = item;
      }
    }, 180);

    document.addEventListener("keydown", this.handleKeydownEvent);
    document.addEventListener("click", this.handleClickOutsideEvent);
  }

  close() {
    this.setAttribute("data-state", "closing");
    this.setAttribute("aria-expanded", "false");

    window.setTimeout(() => {
      this.setAttribute("data-state", "closed");
    }, 180);

    document.removeEventListener("keydown", this.handleKeydownEvent);
    document.removeEventListener("click", this.handleClickOutsideEvent);
  }

  /** @returns {HTMLElement[]} */
  getVisibleItems() {
    // @ts-ignore
    return [...this.listbox.querySelectorAll("[role=option]")].filter(
      // @ts-expect-error
      (el) => el.style.display !== "none"
    );
  }

  isOpen() {
    return this.getAttribute("data-state") === "open";
  }

  /**
   * @param {MouseEvent} event
   */
  handleClickEvent(event) {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (event.target.matches("ui-dropdown-option")) {
      this.selectItem(event.target);
      return;
    }

    event.stopPropagation();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * @param {HTMLElement} item
   */
  selectItem(item) {
    const value = item.getAttribute("value") || "";
    const text = item.innerText;
    this.setAttribute("value", value);

    /** @type {HTMLElement} */
    // @ts-ignore
    const selectedText = this.querySelector(".ui-dropdown-selected__text");
    selectedText.innerText = text;

    const customEvent = new CustomEvent("change", {
      detail: value,
      bubbles: true,
    });
    this.dispatchEvent(customEvent);
    this.triggerButton.focus();
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydownEvent(event) {
    if (event.key === "Escape" || event.key === "esc") {
      this.close();
    }
  }

  /**
   * @param {MouseEvent} _event
   */
  handleClickOutsideEvent(_event) {
    this.close();
  }
}
customElements.define("ui-dropdown", UIDropdown);

const productDataSelector = ".is-product-script-data";

/** @type {import("../types/products").Product | null} */
let productData = null;

class PDPMain extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement|null} */
    this.flavorWidget = this.querySelector("flavor-widget");

    /** @type {HTMLElement|null} */
    this.frequencyWidget = this.querySelector("pdp-frequency");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.priceLine = this.querySelector(".pdp-priceline");

    /** @type {HTMLElement|null} */
    this.packagingWidget = this.querySelector("pdp-packaging");

    /** @type {import('./pdp-atc-button').PdpAtcButton} */
    // @ts-ignore
    this.pdpAtcButton = this.querySelector("pdp-atc-button");

    /** @type {import('./pdp-atc-button').PdpAtcButton} */
    // @ts-ignore
    this.pdpStickyAtcButton = this.querySelector("pdp-sticky pdp-atc-button");

    /** @type {import('./pdp-sticky').PdpSticky} */
    // @ts-expect-error
    this.pdpSticky = this.querySelector("pdp-sticky");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.galleryWidget = this.querySelector("pdp-gallery");

    /** @type {import('../products/back-in-stock').BackInStock | null} */
    this.backInStock = this.querySelector("back-in-stock");

    /** @type {import('./pdp-sticky').PdpSticky | null} */
    this.stickyBar = this.querySelector("pdp-sticky");

    // @ts-ignore
    this.flavorWidget?.addEventListener(
      "change",
      // @ts-ignore
      this.handleFlavorChange.bind(this)
    );

    /** @type {NodeListOf<HTMLElement>} */
    this.quantityInputs = this.querySelectorAll("quantity-input");

    /** @type {import('../products/product-form').ProductForm} */
    // @ts-ignore
    this.productForm = this.querySelector("product-form");

    this.frequencyWidget?.addEventListener(
      "change",
      // @ts-ignore
      this.handleFrequencyChange.bind(this)
    );

    this.packagingWidget?.addEventListener(
      "change",
      // @ts-ignore
      this.handlePackagingChange.bind(this)
    );

    this.quantityInputs.forEach((input) => {
      input.addEventListener("change", this.handleQuantityChange.bind(this));
    });
  }

  connectedCallback() {
    this.saveCurrentProductToRecentlyViewed();
  }

  saveCurrentProductToRecentlyViewed() {
    const [variant, product] = this.getCurrentVariantAndProduct();
    saveViewedProduct(product.id, variant.id, product.handle);
  }

  /**
   * @param {Event} e
   */
  handleQuantityChange(e) {
    /** @type {HTMLInputElement} */
    // @ts-expect-error
    const target = e.currentTarget;

    /** @type {HTMLInputElement} */
    // @ts-expect-error
    const inputTarget = target.querySelector("input[name='quantity']");
    const quantity = inputTarget.valueAsNumber;

    for (const widget of this.quantityInputs) {
      /** @type {HTMLInputElement} */
      // @ts-expect-error
      const inputTarget = widget.querySelector("input[name='quantity']");
      const widgetQty = inputTarget.valueAsNumber;

      if (quantity !== widgetQty) {
        inputTarget.valueAsNumber = quantity;
      }
    }
  }

  /** @param {CustomEvent} e */
  handlePackagingChange(e) {
    if (e.detail.value === "linked") {
      this.navigateToLinkedPDP(e.detail.linkedPDP);
      // trackPackageFilterClicked(, "LinkedPDP");
      return;
    }

    this.flavorWidget?.setAttribute("size", e.detail.value);
  }

  /**
   * @param {import("../types/products").Product} linkedProduct
   */
  navigateToLinkedPDP(linkedProduct) {
    topbar.show();
    const [variant, _product] = this.getCurrentVariantAndProduct();
    const relatedVariant = linkedProduct.variants.find(
      (x) => x.title === variant.title
    );
    const url = relatedVariant
      ? `/products/${linkedProduct.handle}?variant=${relatedVariant.id}`
      : `/products/${linkedProduct.handle}`;

    window.location.href = url;
  }

  /**
   * @param {CustomEvent} _e
   */
  handleFlavorChange(_e) {
    this.syncVariant();
    this.saveCurrentProductToRecentlyViewed();
  }

  /**
   * @param {CustomEvent} _e
   */
  handleFrequencyChange(_e) {
    this.syncVariant();
  }

  /**
   * @returns {["onetime", null] | ["autoship", 1|2|3]}
   */
  getFrequencyInfo() {
    if (!this.frequencyWidget) {
      return ["onetime", null];
    }

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const radio = this.querySelector(".pdp-frequency__item-cb:checked");
    const frequencyType = radio.value;

    /** @type {HTMLElement} */
    // @ts-ignore
    const freq = this.querySelector("ui-dropdown[data-name='frequency']");

    if (frequencyType === "onetime") {
      return ["onetime", null];
    }

    /** @type {1|2|3} */
    // @ts-ignore
    const value = Number(freq.getAttribute("value"));
    return ["autoship", value];
  }

  /**
   * @returns {[import("../types/products").ProductVariant, import("../types/products").Product]}
   */
  getCurrentVariantAndProduct() {
    const product = this.getProduct();
    const value = this.flavorWidget?.getAttribute("value") || "";
    const variant = product.variants.find((x) => x.title === value);

    if (!variant) {
      throw new Error(`Could not find variant for flavor widget: ${value}`);
    }
    return [variant, product];
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   * @param {import("../types/products").Product} _product
   * @param {boolean} updateImages
   */
  updateVariantSpecificContent(variant, _product, updateImages = true) {
    updateContentWithVariant(this, variant.title, updateImages);
    this.updatePriceline(variant);
    this.updateCheckoutBtnText(variant);
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   * @returns {[true, number, number]|[false, number, null]}
   */
  getPriceDetailsFromVariant(variant) {
    const [frequency, _] = this.getFrequencyInfo();

    let comparePrice = null;
    let price = variant.price;

    if (frequency === "autoship") {
      comparePrice = variant.price;
      price = variant.selling_plan_allocations[0].price;
    } else if (variant.price !== variant.compare_at_price) {
      comparePrice = variant.compare_at_price;
    }

    if (comparePrice === null) {
      return [false, price, null];
    }

    return [true, price, comparePrice];
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   */
  updateCheckoutBtnText(variant) {
    const [_type, _] = this.getFrequencyInfo();

    const [_isSale, price, comparePrice] =
      this.getPriceDetailsFromVariant(variant);

    [this.pdpAtcButton, this.pdpStickyAtcButton].forEach((button) => {
      button.setAttribute("price", (price || "").toString());
      button.setAttribute("compare-price", (comparePrice || "").toString());
    });
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   */
  updatePriceline(variant) {
    const [_frequency, _] = this.getFrequencyInfo();

    /** @type {HTMLElement|null} */
    const servingSizeEl = this.priceLine.querySelector(
      ".pdp-priceline__serving"
    );

    /** @type {HTMLElement|null} */
    const cb = this.querySelector(".pdp-packaging__option-cb[checked]");

    /** @type {HTMLElement} */
    // @ts-ignore
    const compareEl = this.priceLine.querySelector(
      "[data-variant-compare-price]"
    );

    /** @type {HTMLElement} */
    // @ts-ignore
    const saleEl = this.priceLine.querySelector("[data-variant-price]");

    const [isSale, price, comparePrice] =
      this.getPriceDetailsFromVariant(variant);

    compareEl.innerText = comparePrice ? formatShopifyPrice(comparePrice) : "";
    saleEl.innerText = formatShopifyPrice(price);

    this.priceLine.classList.toggle("is-sale", isSale);

    if (servingSizeEl && cb) {
      const size = parseInt(cb.dataset.servingSize || "");
      const unitPrice = price / size;
      servingSizeEl.innerText = formatShopifyPrice(unitPrice) + "/serving";
    }
  }

  syncVariant() {
    const [variant, product] = this.getCurrentVariantAndProduct();

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const variantInput = this.productForm.querySelector("input[name='id']");
    const currentVariantID = variantInput.value;

    // If we're changing the variant selling plan, quantity, etc. we need to update
    // some UI, inputs, etc. But we don't want to run our image update logic  since
    // images will be the same (But urls differ slightly). This gets around that
    // to avoid an unnecessary image update.
    const isVariantChanged = currentVariantID !== variant.id.toString();

    this.updateVariantSpecificContent(variant, product, isVariantChanged);

    /** @type {HTMLInputElement|null} */
    const sellingPlanInput = this.productForm.querySelector(
      "input[name='selling_plan']"
    );

    // Update variant input in the form.
    variantInput.value = variant.id.toString();

    if (sellingPlanInput) {
      const plan = this.getCurrentPlan(product);
      sellingPlanInput.value = plan ? String(plan.id) : "";
    }

    const base = window.location.pathname.split("?")[0];
    const url = base + "?variant=" + variant.id;
    window.history.pushState({}, "", url);

    const stockStatus = getStockStatus(this, variant.title);
    this.setAttribute("stock-status", stockStatus);
    this.backInStock?.setAttribute("mode", stockStatus);
    this.backInStock?.setAttribute("variant-id", String(variant.id));
    this.pdpAtcButton.setAttribute("stock-status", stockStatus);
    this.pdpStickyAtcButton.setAttribute("stock-status", stockStatus);
    this.pdpSticky.setAttribute("stock-status", stockStatus);

    this.updateGallery(url);
  }

  /**
   * @param {string} url
   */
  async updateGallery(url) {
    /** @type {HTMLElement} */
    /* @ts-expect-error */
    const wrapper = document.querySelector(".pdp-main__gallery");
    wrapper.classList.add("is-loading");

    url += "&sections=pdp-main";
    const res = await fetch(url);
    const data = await res.json();
    const html = data["pdp-main"];

    /** @type {import('./pdp-gallery').PDPGallery} */
    /* @ts-expect-error */
    const existingGallery = wrapper.querySelector("pdp-gallery");

    /** @type {import('./pdp-gallery').PDPGallery} */
    // @ts-expect-error
    const newGalleryElement = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("pdp-gallery");

    const index = existingGallery.getCurrentIndex();
    existingGallery.replaceWith(newGalleryElement);

    // If sku specific we try and keep the index of the image selected so it matches (if possible).
    if (newGalleryElement.getAttribute("sku-images") === "true") {
      newGalleryElement.setSlideByIndex(index, true);
    }

    wrapper.classList.remove("is-loading");
  }

  /**
   * @param {import("../types/products").Product} product
   * @returns {SellingPlan|null}
   */
  getCurrentPlan(product) {
    const [purchaseType, freq] = this.getFrequencyInfo();

    if (purchaseType === "onetime") {
      return null;
    }

    if (
      !product.selling_plan_groups ||
      product.selling_plan_groups.length === 0
    ) {
      throw new Error("We expecte selling plan groups for subscription types");
    }

    let plans = product.selling_plan_groups[0].selling_plans;

    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];

      if (plan.name.indexOf(`every ${freq} `) !== -1) {
        return plan;
      }
    }
    throw new Error(`Could not find plan for frequency => ${freq}`);
  }

  /**
   * @returns {import("../types/products").Product}
   */
  getProduct() {
    if (productData === null) {
      // @ts-ignore
      productData = getScriptTagJson(productDataSelector, this);
    }

    if (!productData) {
      throw new Error(
        "getProduct() returns null inside product-info component"
      );
    }
    return productData;
  }
}

customElements.define("pdp-main", PDPMain);

class PDPTabs extends HTMLElement {
  constructor() {
    super();

    /** @type {NodeListOf<HTMLDetailsElement>} */
    this.details = this.querySelectorAll("details");

    /** @type {NodeListOf<HTMLElement>} */
    this.summaries = this.querySelectorAll("summary");

    this.handleSummaryClick = this.handleSummaryClick.bind(this);
  }

  connectedCallback() {
    this.summaries.forEach((summary) => {
      summary.addEventListener("click", this.handleSummaryClick);
    });
  }

  /**
   * @param {HTMLDetailsElement} detailsEl
   */
  closeOtherDetails(detailsEl) {
    const allDetails = Array.from(this.querySelectorAll("details"));

    /** @type {HTMLElement[]} */
    // @ts-ignore
    const summaries = allDetails
      .filter((x) => x !== detailsEl)
      .filter((x) => {
        const body = x.querySelector(".pdp-tabs__body");
        const state = body?.getAttribute("data-state") || "idle";
        return state !== "idle";
      })
      .map((x) => x.querySelector("summary"));

    summaries.forEach((x) => {
      x.click();
    });

    if (!isAboveLarge()) {
      this.scrollActiveTabIntoView(detailsEl);
    }
  }

  /**
   * @param {HTMLDetailsElement} detailsEl
   */
  scrollActiveTabIntoView(detailsEl) {
    const allDetails = Array.from(this.querySelectorAll("details"));

    let index = 0;

    for (const el of allDetails) {
      if (el === detailsEl) {
        break;
      }
      index++;
    }

    /** @type {HTMLElement} */
    // @ts-ignore
    const summary = detailsEl.querySelector("summary");
    // iOS will return gap as the row and column pairs, so add this workaround
    const gapRaw = getComputedStyle(this).gap.split(" ")[0];
    const gap = Number(gapRaw.replace("px", ""));
    const startingTop = this.getBoundingClientRect().top + window.scrollY - 100;
    const height = summary.getBoundingClientRect().height;
    const gapAmount = gap * index;
    const detailsOffset = height * index + gapAmount;

    // Add extra gap so spacing is flush
    const newTop = startingTop + detailsOffset - gap;

    if (!isNaN(newTop)) {
      window.scrollTo({ top: newTop, behavior: "smooth" });
    }
  }

  /**
   * @param {Event} e
   */
  handleSummaryClick(e) {
    const summary = e.currentTarget;
    if (!(summary instanceof HTMLElement)) {
      return;
    }

    e.preventDefault();

    /** @type {HTMLDetailsElement} */
    // @ts-ignore
    const detailsEl = summary.parentElement;

    /** @type {HTMLElement} */
    // @ts-ignore
    const contentEl = summary.nextElementSibling;

    /** @type {"idle"|"open"|"opening"|"closing"|"closed"} */
    // @ts-ignore
    let state = contentEl.getAttribute("data-state") || "idle";

    if (detailsEl.getAttribute("open") === null && state !== "idle") {
      contentEl.removeAttribute("data-state");
      state = "idle";
    }

    if (state === "opening" || state === "closing") {
      return;
    }

    this.closeOtherDetails(detailsEl);

    /** @param {any} cb */
    const onAnimationEnd = (cb) =>
      contentEl.addEventListener("animationend", cb, { once: true });

    if (state === "idle" || state === "closed") {
      detailsEl.setAttribute("open", "");
      contentEl.setAttribute("data-state", "opening");

      onAnimationEnd(() => {
        contentEl.setAttribute("data-state", "open");
      });
    } else if (state === "open") {
      contentEl.setAttribute("data-state", "closing");
      onAnimationEnd(() => {
        contentEl.removeAttribute("data-state");
        void contentEl.offsetWidth;
        detailsEl.removeAttribute("open");
      });
    }
  }
}

customElements.define("pdp-tabs", PDPTabs);

class PDPFrequency extends HTMLElement {
  constructor() {
    super();

    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.helpBtn = this.querySelector(".pdp-frequency__help-btn");
    this.helpBtn.addEventListener("click", this.handleHelpBtnClick.bind(this));

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.actionContainer = this.querySelector(".pdp-frequency__item-action");
    this.actionContainer.inert = true;

    /** @type {HTMLInputElement} */
    // @ts-expect-error
    this.autoshipRadio = this.querySelector(
      '.pdp-frequency__item-cb[value="autoship"]'
    );

    /** @type {HTMLInputElement} */
    // @ts-expect-error
    this.onetimeRadio = this.querySelector(
      '.pdp-frequency__item-cb[value="onetime"]'
    );

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.frequencyDropdown = this.querySelector(
      "ui-dropdown[data-name='frequency']"
    );

    this.querySelectorAll(".pdp-frequency__item").forEach((el) => {
      el.addEventListener("click", this.handleItemClick);
    });

    this.querySelectorAll(".pdp-frequency__item-cb").forEach((el) => {
      el.addEventListener("click", this.handleRadioClick);
    });

    /** @type {HTMLElement|null} */
    this.activeElement = null;
    this.currentValue = "onetime";
  }

  /** @param {Event} e */
  handleRadioClick(e) {
    /** @type {HTMLInputElement} */
    // @ts-ignore
    const radio = e.currentTarget;

    this.activeElement = radio;

    if (radio.value === "autoship") {
      this.setAutoshipMode();
    } else if (radio.value === "onetime") {
      this.setOneTimeMode();
    }
  }

  showTerms() {
    const discount = Number(this.getAttribute("data-discount"));
    showModalTerms(discount, () => {}, this.activeElement);
  }

  triggerChange() {
    const event = new CustomEvent("change", {
      detail: this.currentValue,
      bubbles: true,
    });
    this.dispatchEvent(event);
  }

  /**
   * @param {Event} e
   */
  handleHelpBtnClick(e) {
    e.stopPropagation();
    this.activeElement = this.helpBtn;
    this.setAutoshipMode(true);
  }

  setAutoshipMode(forceModal = false) {
    if (this.currentValue === "autoship") {
      if (forceModal) {
        this.showTerms();
      }
      return;
    }

    this.actionContainer.inert = false;
    this.autoshipRadio.checked = true;
    this.frequencyDropdown.tabIndex = 0;
    this.currentValue = "autoship";
    this.triggerChange();
    this.showTerms();
  }

  setOneTimeMode() {
    if (this.currentValue === "onetime") {
      return;
    }

    this.actionContainer.inert = true;
    this.currentValue = "onetime";
    this.onetimeRadio.checked = true;
    this.frequencyDropdown.tabIndex = 0;
    this.triggerChange();
  }

  /**
   * @param {Event} e
   */
  handleItemClick(e) {
    /** @type {HTMLElement} */
    // @ts-ignore
    const target = e.currentTarget;

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const radio = target.querySelector(".pdp-frequency__item-cb");
    const isChanged = radio.checked === false;
    radio.checked = true;
    this.activeElement = radio;

    if (isChanged && radio.value === "autoship") {
      this.setAutoshipMode();
    } else if (isChanged && radio.value === "onetime") {
      this.setOneTimeMode();
    }
  }
}

customElements.define("pdp-frequency", PDPFrequency);

class PDPPackaging extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".pdp-packaging__option-cb").forEach((el) => {
      el.addEventListener("change", this.handleChange.bind(this));
    });
  }

  /**
   * @param {Event} e
   */
  handleChange(e) {
    e.stopPropagation();
    e.preventDefault();

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const target = e.target;
    const value = target.value;

    let linkedProduct = null;

    if (value === "linked") {
      linkedProduct = JSON.parse(target.dataset.linkedPdp || "");
    }

    this.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          value: value,
          linkedPDP: linkedProduct,
        },
      })
    );
  }
}

customElements.define("pdp-packaging", PDPPackaging);

class PDPGallery extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-ignore
    this.slider = this.querySelector(".pdp-gallery__media-slider");

    /** @type {NodeListOf<HTMLElement>} */
    this.thumbnails = this.querySelectorAll(".pdp-gallery__thumbnail");

    /** @type {NodeListOf<HTMLElement>} */
    this.arrowBtns = this.querySelectorAll(
      ".pdp-gallery__thumbnails-arrow-btn"
    );

    /**
     * @type {NodeListOf<HTMLVideoElement>}
     */
    this.videos = this.querySelectorAll("video.pdp-gallery__media-img");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.similarProductsBtn = this.querySelector(".pdp-gallery__oos-alert-btn");

    this.onClickThumbnail = this.onClickThumbnail.bind(this);
    this.onSliderScrollEnd = this.onSliderScrollEnd.bind(this);
    this.onClickArrowBtn = this.onClickArrowBtn.bind(this);
    this.onClickSimilarProductsBtn = this.onClickSimilarProductsBtn.bind(this);
    this.onClickVideo = this.onClickVideo.bind(this);
    this.onClickToggleSoundBtn = this.onClickToggleSoundBtn.bind(this);
  }

  connectedCallback() {
    this.thumbnails.forEach((el, index) => {
      el.addEventListener("click", this.onClickThumbnail);
      el.setAttribute("data-index", index.toString());
    });
    this.arrowBtns.forEach((el) => {
      el.addEventListener("click", this.onClickArrowBtn);
    });
    this.slider.addEventListener("scrollend", this.onSliderScrollEnd);
    this.similarProductsBtn.addEventListener(
      "click",
      this.onClickSimilarProductsBtn
    );

    this.videos.forEach((video) => {
      video.addEventListener("click", this.onClickVideo);
      // @ts-ignore
      video.parentElement
        ?.querySelector(".pdp-gallery__toggle-sound-btn")
        .addEventListener("click", this.onClickToggleSoundBtn);
    });
  }

  /**
   * @param {Event} e
   */
  onClickVideo(e) {
    /** @type {HTMLVideoElement} */
    // @ts-ignore
    const video = e.currentTarget;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  onClickSimilarProductsBtn() {
    const anchor = document.querySelector(".pdp-recs__scroll-anchor");
    if (anchor) {
      anchor.scrollIntoView();
    }
  }

  /** @param {Event} e */
  onClickToggleSoundBtn(e) {
    /** @type {HTMLElement} */
    // @ts-ignore
    const target = e.currentTarget;
    /** @type {HTMLElement} */

    // @ts-ignore
    const container = target.closest(".pdp-gallery__slide-container");

    /** @type {HTMLVideoElement} */
    // @ts-ignore
    const video = container.querySelector("video");

    if (video.muted) {
      video.muted = false;
    } else {
      video.muted = true;
    }

    target.setAttribute("data-sound", video.muted ? "off" : "on");
  }

  /**
   * @param {Event} e
   */
  onClickArrowBtn(e) {
    /** @type {"up"|"down"} */
    // @ts-ignore
    const direction = e.currentTarget.dataset.dir;

    /** @type {HTMLElement|null} */
    const activeThumbnail = this.querySelector(
      ".pdp-gallery__thumbnail.is-active"
    );

    if (!activeThumbnail) {
      this.setSlideByIndex(0, true);
      return;
    }

    const currentIndex = parseInt(activeThumbnail.dataset.index || "");

    if (direction === "up") {
      const newIndex =
        currentIndex === 0 ? this.thumbnails.length - 1 : currentIndex - 1;
      this.setSlideByIndex(newIndex, true);
    } else if (direction === "down") {
      const newIndex =
        currentIndex === this.thumbnails.length - 1 ? 0 : currentIndex + 1;
      this.setSlideByIndex(newIndex, true);
    }
  }

  /**
   * @param {Event} e
   */
  onSliderScrollEnd(e) {
    const firstImage = this.slider.firstElementChild;
    if (firstImage) {
      const slideWidth = firstImage.getBoundingClientRect().width;
      const newIndex = Math.round(this.slider.scrollLeft / slideWidth);
      this.setSlideByIndex(newIndex, false);
    }
  }

  /**
   * @param {Event} e
   */
  onClickThumbnail(e) {
    // @ts-ignore
    const index = parseInt(e.currentTarget.dataset.index);
    this.setSlideByIndex(index, true);
  }

  getCurrentIndex() {
    /** @type {HTMLElement}  */
    // @ts-ignore
    const currentActive = this.querySelector(
      ".pdp-gallery__thumbnail.is-active"
    );

    return parseInt(currentActive.dataset.index || "0");
  }

  /**
   * @param {number} index
   * @param {boolean} triggerScroll
   */
  setSlideByIndex(index, triggerScroll) {
    if (index >= this.thumbnails.length) {
      index = 0;
    }

    const firstImage = this.slider.firstElementChild;

    if (!firstImage) {
      return;
    }

    /** @type {HTMLElement}  */
    // @ts-ignore
    const currentActive = this.querySelector(
      ".pdp-gallery__thumbnail.is-active"
    );

    if (parseInt(currentActive.dataset.index || "") === index) {
      return;
    }

    if (triggerScroll) {
      const slideWidth = firstImage.getBoundingClientRect().width;
      const newScrollLeft = slideWidth * index;
      this.slider.scrollLeft = newScrollLeft;
    }

    const mediaSlider = this.slider.querySelectorAll(".pdp-gallery__media-img");

    /** @type {HTMLElement} */
    // @ts-ignore
    const activeMedia = mediaSlider[index];

    /** @type {NodeListOf<HTMLVideoElement>} */
    const videos = this.slider.querySelectorAll("video.pdp-gallery__media-img");

    // Pause any other videos
    videos.forEach((video) => {
      if (video.currentTime > 0) {
        video.pause();
      }
    });

    if (activeMedia.tagName === "VIDEO") {
      // @ts-ignore
      activeMedia.play();
    }

    this.thumbnails.forEach((el) => {
      if (el.dataset.index === `${index}`) {
        el.classList.add("is-active");
        this.scrollThumbnails(index);
      } else {
        el.classList.remove("is-active");
      }
    });
  }

  /**
   * @param {number} index
   */
  scrollThumbnails(index) {
    /** @type {HTMLElement} */
    // @ts-ignore
    const slider = this.querySelector(".pdp-gallery__thumbnails");
    const css = window.getComputedStyle(slider);
    const snapType = css.getPropertyValue("scroll-snap-type");

    // Mobile is "x mandatory""
    if (snapType.startsWith("x")) {
      const width = this.thumbnails[0].clientHeight;
      const newScrollLeft = width * index;
      slider.scrollLeft = newScrollLeft;
    } else {
      const height = this.thumbnails[0].clientHeight;
      const newScrollTop = height * index;
      slider.scrollTop = newScrollTop;
    }
  }
}

customElements.define("pdp-gallery", PDPGallery);

class PdpAtcButton extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement} */
    // @ts-ignore
    this.button = this.querySelector(".pdp-atc-button__btn");

    this.button.addEventListener("click", this.handleClick.bind(this));
  }

  static get observedAttributes() {
    return ["loading", "price", "compare-price"];
  }

  /**
   * @param {"loading"|"price"|"compare-price"} name
   */
  attributeChangedCallback(name) {
    if (name === "loading") {
      this.updateLoadingStatus();
      return;
    }
    this.updateButtonText();
  }

  /**
   * @param {MouseEvent} e
   */
  handleClick(e) {
    if (!this.querySelector("[data-disclaimer-anchor]")) {
      return;
    }
    const product = getProductData(this);

    console.log(product);
    if (product.selling_plan_groups.length === 0) {
      return;
    }

    const variantId = Number(
      // @ts-ignore
      this.closest("product-form").querySelector("input[name='id']").value
    );

    // @ts-ignore
    const qty = Number(this.querySelector("input[name='quantity']").value);
    const variant = product.variants.find((x) => x.id === variantId);
    if (!variant) {
      console.error("Could not find variant for product atc button", this);
      return;
    }

    /** @type {HTMLElement|null} */
    const productContainer = this.closest("[data-product-scope]");

    if (!productContainer) {
      console.error(
        "[PDP-ATC-BUTTON] Could not find product container for atc button",
        this
      );
      return;
    }

    e.preventDefault();

    ModalAtcDisclaimer.show(productContainer, product, variant, qty);
  }

  updateLoadingStatus() {
    if (this.hasAttribute("loading")) {
      this.button.setAttribute("aria-disabled", "true");
      this.button.dataset.state = "submitting";
    } else {
      this.button.removeAttribute("aria-disabled");
      this.button.dataset.state = "idle";
    }
  }

  updateButtonText() {
    const price = this.getAttribute("price");
    const comparePrice = this.getAttribute("compare-price") || "";

    /** @type {HTMLElement} */
    // @ts-ignore
    const comparePriceEl = this.querySelector("[data-compare-price]");

    /** @type {HTMLElement} */
    // @ts-ignore
    const priceEl = this.querySelector("[data-price]");

    if (comparePrice) {
      comparePriceEl.innerText = formatShopifyPrice(comparePrice);
      priceEl.innerText = formatShopifyPrice(price);
      this.setAttribute("comparing", "");
    } else {
      priceEl.innerText = formatShopifyPrice(price);
      comparePriceEl.innerText = "";
      this.removeAttribute("comparing");
    }
  }
}

customElements.define("pdp-atc-button", PdpAtcButton);

class PdpSticky extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement[]} */
    this.triggerElements = Array.from(
      document.querySelectorAll(
        "pdp-content product-form,pdp-content .pdp-email-capture__submit-btn"
      )
    );

    /**
     * @type {HTMLElement} */
    /* @ts-expect-error */
    this.endElement = document.querySelector(".footer-disclaimer");

    /** @type {HTMLElement} */
    /* @ts-expect-error */
    this.notificationsBtn = document.querySelector(
      ".pdp-sticky__notifications-btn"
    );
    this.init();
  }

  init() {
    this.observer = new IntersectionObserver(this.observe.bind(this), {
      rootMargin: `-100px 0px 0px 0px`,
    });

    for (const trigger of this.triggerElements) {
      this.observer.observe(trigger);
    }

    this.observer.observe(this.endElement);

    this.notificationsBtn.addEventListener(
      "click",
      this.handleNotificationClick.bind(this)
    );
  }

  handleNotificationClick() {
    const form = document.querySelector("pdp-main back-in-stock");
    if (form) {
      const newTop = form.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: newTop, behavior: "smooth" });
    }
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  observe(entries) {
    const entry = entries[0];

    /** @type {HTMLElement} */
    // @ts-expect-error
    const target = entry.target;

    if (this.triggerElements.includes(target)) {
      if (!entry.isIntersecting && entry.boundingClientRect.top <= 100) {
        this.show();
      } else {
        this.hide();
      }
    } else if (entry.target === this.endElement) {
      if (entry.isIntersecting) {
        this.hide();
      } else {
        this.show();
      }
    }
  }

  show() {
    const state = this.getAttribute("state");
    if (state === "opening" || state === "open") {
      return;
    }

    this.setAttribute("state", "opening");
    window.setTimeout(() => {
      this.setAttribute("state", "open");
    }, 10);
  }

  hide() {
    const state = this.getAttribute("state");
    if (state === "closing" || state === "closed") {
      return;
    }

    this.setAttribute("state", "closing");
    window.setTimeout(() => {
      this.setAttribute("state", "closed");
    }, 300);
  }
}

customElements.define("pdp-sticky", PdpSticky);
